import z, { ZodType } from "zod";
import { type ShadeCharacteristics } from "./shadeCharacteristics.types";

export const shadeCharacteristicsSchema: ZodType<ShadeCharacteristics> = z.xor([
  z.object({
    shadeType: z.string(),
    isMultiShade: z.literal(false),
    shade: z.string(),
  }),
  z.object({
    shadeType: z.string(),
    isMultiShade: z.literal(true),
    baseShade: z.string(),
    incisalShade: z.string(),
    gingivalShade: z.string(),
  }),
]);
